import { FC } from "react"
import { AttentionsInfoMail } from "../../../module/attentions/containers/infoMail"

export const AttentionsInfoMailPage: FC = () => <AttentionsInfoMail />
